import React from 'react';

import { IMAGE_SPACER_3_4 } from 'website/configuration/constants';

import styles from './styles.module.scss';

export type Props = {
  lazy: boolean;
  src: string;
  title?: string;
};

const SuggestionImage = ({ lazy, title, src }: Props) => {
  return (
    <img
      className={styles.suggestionImage}
      title={title}
      src={lazy ? IMAGE_SPACER_3_4 : src}
      data-src={lazy ? src : null}
      width="216"
      height="288"
    />
  );
};

export default SuggestionImage;
